import React from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import { STATIC_ATTRIBUTES } from '@client/components/blocks/Text/plugins/constants'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'

const VIEW_IN_BROWSER_MARKUP = `##${STATIC_ATTRIBUTES[0].code}##`

export const RequiredLinksHeader = ({
  editor = EditorModelNULL,
  app = AppModelNULL,
  serverRender = false,
}) => {
  const { missingAttrs } = editor
  const viewOnlineIsMissing = missingAttrs.includes(VIEW_IN_BROWSER_MARKUP)

  return (
    <If condition={viewOnlineIsMissing}>
      <div>
        <table
          className={serverRender ? '' : 'section'}
          role="presentation"
          cellSpacing="0"
          cellPadding="0"
          border="0"
          align="center"
          width="100%"
          style={{
            borderSpacing: '0',
            color: '#666666',
            fontFamily: 'sans-serif',
          }}
        >
          <tbody>
            <tr>
              <td align="center">
                <p
                  style={{
                    color: '#666666',
                    fontSize: '12px',
                    margin: '10px 20px',
                  }}
                >
                  {app.formatMessage('requiredLinksHeader.message')}&nbsp;
                  <a
                    style={{ color: '#666666', textDecoration: 'underline' }}
                    target="_blank"
                    href="##view_online##"
                  >
                    {app.formatMessage('requiredLinksHeader.viewOnlineLink')}
                  </a>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </If>
  )
}

RequiredLinksHeader.propTypes = {
  app: PropTypes.instanceOf(AppModel),
  editor: PropTypes.instanceOf(EditorModel),
  serverRender: PropTypes.bool,
}

export default inject(
  'editor',
  'app',
  'serverRender'
)(observer(RequiredLinksHeader))
